import { useState } from 'react'
import { Form, Head, Link } from '@inertiajs/react'
import { Input, Button } from 'antd'

import LoginLayout from '@/components/layouts/LoginLayout'
import DeviceUserCard from '@/components/DeviceUserCard'

interface EditPasswordProps {
  current_user: {
    id: number
    email: string
    name?: string
    global_admin: boolean
  }
  has_password: boolean
  return_path: string
  csrf_token: string
}

export default function EditPassword({
  has_password,
  return_path,
  csrf_token,
}: EditPasswordProps) {
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')

  const title = has_password ? 'Change Password' : 'Set Password'

  return (
    <LoginLayout>
      <Head title={title} />
      <DeviceUserCard title={title}>
        <p className="text-sm text-gray-500 mb-5">
          {has_password
            ? 'Enter a new password below.'
            : 'You currently don\'t have a password set. Set one to enable password login in addition to OTP.'}
        </p>

        <Form
          action="/account/password"
          method="put"
          onSuccess={() => {
            setLoading(false)
            setPassword('')
            setPasswordConfirmation('')
          }}
          onError={() => {
            setLoading(false)
          }}
          onSubmit={() => setLoading(true)}
        >
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <input type="hidden" name="_method" value="put" />

          <div className="mb-5">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              {has_password ? 'New Password' : 'Password'}
            </label>
            <Input.Password
              id="password"
              name="user[password]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={has_password ? 'Enter new password' : 'Enter password'}
              required
            />
            <p className="text-xs text-gray-500 mt-1">Minimum 6 characters</p>
          </div>

          <div className="mb-5">
            <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password
            </label>
            <Input.Password
              id="password_confirmation"
              name="user[password_confirmation]"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              placeholder="Confirm password"
              required
            />
          </div>

          <div className="flex justify-between items-center mt-6">
            <Link
              href={return_path}
              className="text-blue-500 no-underline text-sm"
            >
              Cancel
            </Link>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={!password || !passwordConfirmation}
            >
              {has_password ? 'Change Password' : 'Set Password'}
            </Button>
          </div>
        </Form>
      </DeviceUserCard>
    </LoginLayout>
  )
}
